import { render, staticRenderFns } from "./ResourceSeatingCapacity.vue?vue&type=template&id=23ae0567&scoped=true"
import script from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"
export * from "./ResourceSeatingCapacity.vue?vue&type=script&lang=js"
import style0 from "./ResourceSeatingCapacity.vue?vue&type=style&index=0&id=23ae0567&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae0567",
  null
  
)

export default component.exports